import { INameId } from '@modeso/types__aumico-lib-core-be';

export interface IUserGeneralInformation {
    salutation?: string;
    name?: string;
    surname?: string;
    email: string;
    phone?: string;
    language?: string;
    country?: INameId;
}
